export default __webpack_public_path__ + "static/media/pd5.4747e2da.jpg";